export default "__VITE_ASSET__RMyn7PKI__"